<template>
  <div>
    <div style="margin-bottom: 20px;margin-top: 30px">
    </div>
    <w-table :columns="columns" :table-data="tableData" ref="wMyTable"
             @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
             :page="page" @pageChange="handlePagePagination">
      <div slot="type" slot-scope="{text,record}">
        <div v-if="text === 'CREATE'">创建</div>
        <div v-else-if="text === 'UPDATE'">修改</div>
        <div v-else-if="text === 'DELETE'">删除</div>
      </div>
      <div slot="msg" slot-scope="{text,record}">
        <el-tag v-if="text === '操作成功'" type="success">成 功</el-tag>
        <el-tag v-else-if="text === '操作失败'" type="danger">失 败</el-tag>
        <el-tag v-else type="info">未知状态</el-tag>
      </div>
      <div slot="filterType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
           style="padding: 8px; position: relative; z-index: 9999 !important;width:250px">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-radio label='创建'>创建</el-radio>
              </el-col>
              <el-col :span="8">
                <el-radio label='修改'>修改</el-radio>
              </el-col>
              <el-col :span="8">
                <el-radio label='删除'>删除</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
      <div slot="eventIds" slot-scope="{text,record}">
        <div class="status-tag-container">{{ text.join(',') }}</div>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
  </div>
</template>

<script>
import {getLogPage} from "@/api/dilivery/operationlog";
import {log} from "@/utils/data/tableCol/operationlog/log";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";

export default {
  name: "Log",
  components: {PictureLoading, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      selectDetail: '',
      selectType: {},
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      loading:true,
      deleterInfo: {},
      showDeleteDialog: false,
    }
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(log(this.searchConditionTag || {})))
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    // 获取数据
    getData(type) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        this.sortConditionTag.forEach(item => {
          params["order"] = item.colName + "." + item.order
        })
        params['page.current'] = 1
        params['page.size'] = 10
      }
      let sendData = {}
      sendData = this.getSearch(sendData)
      getLogPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        if (item.key==='type'){
          let value
          if (item.value==='创建'){
            value='CREATE'
          }else if (item.value==='修改'){
            value='UPDATE'
          }else {
            value='DELETE'
          }
          sendData["query#" + item.key + ".LIKE"] = value
        }else {
          sendData["query#" + item.key + ".LIKE"] = item.value
        }
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}
</style>
